import React from 'react';
import * as _ from 'lodash';
import cx from 'classnames';
// eslint-disable-next-line restrict-imports/restrict-imports
import { makeStyles } from 'design-system/product/theme';
import { Typography as MaterialTypography, TypographyProps } from '@material-ui/core';

type CustomTypographyProps = {
  weight?: 'regular' | 'bold';
  mono?: boolean;
  component?: string;
} & TypographyProps;

export const Typography: React.FC<CustomTypographyProps> = (props: CustomTypographyProps) => {
  const classes = useStyles();
  const typographyProps = _.omit(props, ['weight', 'mono']);

  const rootClasses = cx({
    [classes.bold]: props.weight === 'bold',
    [classes.regular]: props.weight === 'regular',
    [classes.mono]: props.mono,
  });
  return (
    <MaterialTypography classes={{ root: rootClasses }} {...typographyProps}>
      {props.children}
    </MaterialTypography>
  );
};

const useStyles = makeStyles(theme => ({
  bold: {
    fontWeight: 500,
  },
  regular: {
    fontWeight: 400,
  },
  mono: {
    fontFamily: theme.typography.fontFamilyMono,
  },
}));
